<template>
    <div>
        <div class='apply' v-if="!quotaData.availableLines">
            <div v-if="applyStatus===''">未开启账期，点击<span style="color:blue;cursor: pointer;" @click="getAppay">申请</span></div>
            <div v-else>审核状态：{{getStatus(this.applyStatus)}}</div>
            
        </div>
        <div class="uc-content" v-else>
            <div class="container">
                <!-- row -->
                <div class="row">
                    <!-- Left colunm -->
                    <!-- <?php $this->userLeftWidgets(); ?> -->

                    <div class="center_column col-xs-12 col-sm-9">
                        <!-- view-product-list-->
                        <div class="uc-box uc-main-box">
                            <div class="uc-content-box">
                                <div class="box-hd">
                                    <h1 class="title">
                                        我的账期
                                    </h1>
                                    <div class="page-heading"></div>
                                </div>
                                <div class="box-bd" style="padding-top: 25px;">
                                    <div class="cash-overall">
                                        <div class="balance">
                                            可用额度：￥{{ quotaData.availableLines }}
                                        </div>
                                        <div class="balance">
                                            总额度：￥{{ quotaData.userLines }}
                                        </div>
                                        <div class="balance">
                                            利率：{{ quotaData.rate }}%/天
                                        </div>
                                        <div class="balance">
                                            我的账单：待还款￥{{ quotaData.repaymentAmount }}
                                        </div>

                                        <div class="balance">
                                            状态：{{ getStatus(quotaData.applyStatus) }}

                                        </div>

                                    </div>
                                    <!-- <div class="page-heading" style="margin-top:-40px"></div> -->
                                </div>
                                <div class="panel">
                                    <div class="panel-body nav-tabs-animate">
                                        <ul class="nav nav-tabs nav-tabs-line tabList" role="tablist">
                                            <li @click='tabs = 0' role="presentation" class="news"
                                                :class="{ col: tabs == 0 }">
                                                白条明细
                                            </li>
                                            <li @click='tabs = 1' role="presentation" class="news"
                                                :class="{ col: tabs == 1 }">
                                                白条账单
                                            </li>
                                            <li @click='tabs = 2' role="presentation" class="news"
                                                :class="{ col: tabs == 2 }">
                                                还款记录
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class='stripeList' v-show="tabs == 0">
                                <el-table border :data="qutaList" style="width: 100%">
                                    <el-table-column prop="createTime" label="添加时间" width="220">
                                    </el-table-column>
                                    <el-table-column prop="amount" label="额度变更" width="220">
                                    </el-table-column>
                                    <el-table-column label="描述">
                                        <template slot-scope="scope">
                                            <div>{{scope.row.title}}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div>第 {{pageNum}} 页 ( 总共 {{Math.ceil(total1/10)}} 页 ) (从 {{Math.ceil(total1/10)}} 条记录过滤)</div>
                                <el-pagination @current-change="handleCurrentChange" :current-page="pageNum"
                                    background layout="prev, pager, next" :total="total1">
                                </el-pagination>
                            </div>
                            <div class='stripeList' v-show="tabs == 1">
                                <el-table border :data="tableData" style="width: 100%">
                                    <el-table-column prop="amount" label="消费金额(￥)">
                                    </el-table-column>
                                    <el-table-column prop="createTime" label="付款时间">
                                    </el-table-column>
                                    <el-table-column  label="分期(天)">
                                        
                                        <template slot-scope="scope">
                                            {{scope.row.installmentDays}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="rate" label="利率(%/天)">
                                    </el-table-column>
                                    <el-table-column prop="aclAmount" label="实际还款">
                                    </el-table-column>
                                    <el-table-column label="还款状态">
                                        <template slot-scope="scope">
                                            {{getmouseStatus(scope.row.status)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="deadlineTime" label="还款日期">
                                    </el-table-column>
                                    <el-table-column  label="操作" align="center">
                                        <template slot-scope="scope">
                                            <el-button size="mini" type="success" round @click="details(scope.row)">详情
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div>第 {{pageNum3}} 页 ( 总共 {{Math.ceil(total2/10)}} 页 ) (从 {{Math.ceil(total2/10)}} 条记录过滤)</div>
                                <el-pagination @current-change="billChange" :current-page="pageNum3"
                                    background layout="prev, pager, next" :total="total2">
                                </el-pagination>
                            </div>
                            <div class='stripeList' v-show="tabs == 2">
                                <el-table border :data="billList" style="width: 100%">
                                    <el-table-column prop="deadlineTime" label="时间">
                                    </el-table-column>
                                    <el-table-column prop="amount" label="金额(￥)">
                                    </el-table-column>
                                    <el-table-column label="状态">
                                        <template  slot-scope="scope">
                                            {{getmouseStatus(scope.row.status)}}{{scope.row.auditStatus?[getfillStatus(scope.row.auditStatus)]:''}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="描述">
                                        <template  slot-scope="scope">
                                            {{scope.row.type?'线下':'线上'}}还款
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div>第 {{pageNum2}} 页 ( 总共 {{Math.ceil(total3/10)}} 页 ) (从 {{Math.ceil(total3/10)}} 条记录过滤)</div>
                                <el-pagination @current-change="recordChange" :current-page="pageNum2"
                                    background layout="prev, pager, next" :total="total3" :page-size='pageSize'>
                                </el-pagination>
                            </div>
                            <div class="sortPagiBar">
                                <div class="bottom-pagination">
                                    <nav>
                                        <!-- <?php
                                $tmp = $_GET;
                                unset($tmp['page']);
                                echo Zero_Page::multipage($data['total'],  $data['page'],  $tmp);
                                ?> -->
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ModuleGet, getDetailed, getBill,getRepayment ,getTypes} from '@/api/xunyou'
export default {

    data() {
        return {
            tabs: 0,
            quotaData: '',
            qutaList: [],
            userData: JSON.parse(localStorage.getItem("userdata")),
            tableData: [],
            currentPage1: 5,
            pageSize: 5,
            pageNum: 1,
            pageNum2: 1,
            pageNum3: 1,
            billList: [],
            total1:0,
            total2:0,
            total3:0,
            applyStatus:''
        };
    },
    components: {},
    created() {
        this.getMystripe()
        this.getType()
    },
    mounted() {
    },
    methods: {
        getType(){
            const userInfo = JSON.parse(localStorage.getItem("userdata"));
          
            getTypes({type:1,userId:userInfo.userId}).then(res=>{
                this.applyStatus = res.data.applyStatus
            })
        },
        getStatus(val) {
            switch (val) {
                case 0:
                    return '待审核';
                    break;
                case 1:
                    return '已审核';
                    break;
                case 2:
                    return '已拒绝';
                    break;
            }
        },
        getfillStatus(val) {
            switch (val) {
                case 0:
                    return '待审核';
                    break;
                case 1:
                    return '审核通过';
                    break;
                case 2:
                    return '拒绝通过';
                    break;
            }
        },
        getmouseStatus(val) {
            switch (val) {
                case 0:
                    return '待还款';
                    break;
                case 1:
                    return '已还款';
                    break;
                case 2:
                    return '已逾期';
                    break;
            }
        },
        getMystripe() {
            ModuleGet({ type: 1, userId: this.userData.userId }).then(res => {
                this.quotaData = res.data
                console.log("-----"+res.data);
                this.getDetails()
                this.getBills()
                this.getRepayments()
            })
        },
        getBills() {
            const arr = {
                id: this.quotaData.id,
                pageNum: this.pageNum2,
                pageSize: this.currentPage1
            }
            getBill(arr).then(res => {
                this.billList = res.data.rows
                this.total3 = res.data.total
                console.log(this.total3,'total3total3')
            })
        },
        getRepayments() {
            const arr = {
                id: this.quotaData.id,
                pageNum: this.pageNum3,
                pageSize: this.currentPage1
            }
            getRepayment(arr).then(res => {
                this.tableData = res.data.rows
                this.total2 = res.data.total
                console.log(res.data.rows,'14561651')
            })
        },
        getDetails() {
            const arr = {
                id: this.quotaData.id,
                pageNum: this.pageNum,
                pageSize: this.currentPage1
            }
            getDetailed(arr).then(res => {
                this.qutaList = res.data.rows
                this.total1 = res.data.total
            })
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val
            this.getDetails()
        },
        billChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum3 = val
            this.getRepayments()
        },
        recordChange(val) {
            this.pageNum2 = val
            this.getBills()
        },
        details(val) {
            this.$router.push({ path: '/stripeDetails', query: { detailsId: val.detailsId } })
        },
        getAppay() {
            this.$router.push({ path: '/myAppay', query: { type: 1 } })
        }
    }
};
</script>

<style scoped lang="less">
.ecard-table {
    width: 100%;
    margin: 30px 0 20px;
}

.number {
    width: auto !important;
}

.panel {
    padding: 15px;

    .nav {
        display: flex;
    }

    li {
        margin-right: 2px;
        line-height: 1.42857;
        border: 1px solid transparent;
        border-radius: 4px 4px 0 0;
        cursor: pointer;

        &:hover {
            background-color: #eee;
            color: #ff6700;
        }
    }
}

.cash-overall {
    display: flex;
}

.box-hd {
    .title {
        margin: 0;
        font-size: 30px;
        font-weight: 400;
        line-height: 68px;
        color: #757575;
    }
}

.balance {
    margin-right: 35px;
}

.box-bd {
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 20px;
}

.col {
    color: #ff6700 !important;
    background-color: transparent !important;
    border: 1px solid #ddd !important;
    border-bottom: 2px solid #ff6700 !important;
}

.news {
    padding: 10px 15px;
}

/deep/ .has-gutter th {
    background: rgba(238, 238, 238);
}

/deep/ .el-pager li {
    padding: 0 16px;
    height: 37px;
    line-height: 37px;
}

/deep/ .el-pagination {
    margin-left: 300px;
}

/deep/ .btn-prev,
/deep/ .btn-next {
    padding: 0 16px;
    height: 37px;
    line-height: 37px;

}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;

}

.stripeList {
    div {
        font-size: 14px;
        padding: 10px 0 0;
    }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/myPeriod.vue